/**
 * Relay ↔ browser WebSocket bridge — browser raw UDP gönderemediği için
 * WebSocket tabanlı TCP/TLS tunnel. Relay tarafı WebSocket frame'leri 11-byte
 * PhotonRemote header'lı UDP paketlerine dönüştürüp host'a iletir.
 *
 * Protocol: binary WebSocket frames = raw PhotonRemote UDP packet wire bytes.
 * Connect URL'de session_id + JWT query param.
 */
export class WsBridge {
    ws = null;
    onPacket = () => { };
    _connected = false;
    onStateChange = new Set();
    get isConnected() {
        return this._connected;
    }
    /**
     * Faz V: relaySessionId (24-bit) paramı zorunlu. Bağlantı kurulur kurulmaz
     * boş bir "bind ping" paketi yollanır — relay first-packet-binds ile bu
     * session'a mapleme yapar. Aksi halde client video/audio kabul eder ama
     * ilk input'a kadar relay iki ucu eşleştiremez (iPad gibi dokunma akmadan
     * siyah kalan senaryo).
     */
    connect(relayUrl, sessionId, jwt, relaySessionId24) {
        return new Promise((resolve, reject) => {
            // Faz V: URL session paramı relay'in 24-bit session_id'si (decimal).
            // Relay bunu aldığı anda endpoint'i kaydeder → host-agent'tan gelen
            // paketleri hemen iPad/browser'a forward eder. Bind ping fallback
            // olarak kalır (bu yollanmazsa URL hint yeterli).
            const qSession = (typeof relaySessionId24 === 'number' && relaySessionId24 > 0)
                ? String(relaySessionId24 & 0x00ffffff)
                : encodeURIComponent(sessionId); // legacy: GUID string (relay parse edemez → ignore)
            const url = `${relayUrl}/ws?session=${qSession}&jwt=${encodeURIComponent(jwt)}`;
            const ws = new WebSocket(url);
            ws.binaryType = 'arraybuffer';
            ws.onopen = () => {
                this._connected = true;
                this.notifyState();
                // Bind ping: 11-byte header, type=Ping(3), session_id=u24, seq=0,
                // channel=Control(0), length=0. Payload yok — relay tarafında
                // session tablosuna endpoint kaydı yeterli.
                if (typeof relaySessionId24 === 'number' && relaySessionId24 > 0) {
                    const bind = new Uint8Array(11);
                    bind[0] = (0 << 6) | ((3 & 0x7) << 3) | 0; // version=0, type=Ping, flags=0
                    bind[1] = (relaySessionId24 >> 16) & 0xff;
                    bind[2] = (relaySessionId24 >> 8) & 0xff;
                    bind[3] = relaySessionId24 & 0xff;
                    // seq=0, channel=0, payload_len=0 (hepsi zaten 0)
                    try {
                        ws.send(bind);
                    }
                    catch { /* ws henüz ready değilse ignore */ }
                }
                resolve();
            };
            ws.onmessage = (ev) => {
                if (ev.data instanceof ArrayBuffer) {
                    this.onPacket(new Uint8Array(ev.data));
                }
            };
            ws.onerror = (e) => {
                if (!this._connected)
                    reject(new Error(`ws connect hata: ${e}`));
            };
            ws.onclose = () => {
                this._connected = false;
                this.notifyState();
            };
            this.ws = ws;
        });
    }
    setOnPacket(fn) {
        this.onPacket = fn;
    }
    send(bytes) {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN)
            return;
        this.ws.send(bytes);
    }
    close() {
        this.ws?.close();
        this.ws = null;
        this._connected = false;
        this.notifyState();
    }
    notifyState() {
        for (const fn of this.onStateChange)
            fn();
    }
}
